import type { DependencyList, EffectCallback } from 'react'
import { useDeepCompareEffect as useDeepCompareEffectCore } from 'react-use'

export const useDeepCompareEffect = (effect: EffectCallback, deps?: DependencyList) => {
  return useDeepCompareEffectCore(effect, deps)
}
